import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { StatisticsComponent } from './statistics.component';
import { StatisticsCustomersComponent } from './statistics-customers/statistics-customers.component';
import { StatisticsEventsComponent } from './statistics-events/statistics-events.component';
export const STATISTICS_ROUTES: Routes = [
    {
        path: 'statistics', component: StatisticsComponent, canActivate: [AuthGuard], children: [
          { path: 'customers', component: StatisticsCustomersComponent, canActivate: [AuthGuard] },
          { path: 'events', component: StatisticsEventsComponent, canActivate: [AuthGuard] }
        ]
    }
];
